import { render, staticRenderFns } from "./CustomerActivity.vue?vue&type=template&id=2caa5b5c"
import script from "./CustomerActivity.vue?vue&type=script&lang=js"
export * from "./CustomerActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports